import { useState, useEffect } from "react";
import AgentsAPI from "../../../api/AgentsAPI";

const useFetchAgentsDetails = () => {
	const [loading, setLoading] = useState(false);
	const [agents, setAgents] = useState([]);

	const fetchAgentsDetails = async () => {
		setLoading(true);
		try {
			const result = await AgentsAPI.getAllAgentsDetails();
			setAgents(preprocessData(result));
		} catch (error) {
			console.error("Failed to fetch agents:", error);
			setAgents([]);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchAgentsDetails();
	}, []);

	const preprocessData = (agents) => {
		return agents.map((agent) => ({
			...agent,
			avatar: agent.avatar || `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(agent.display_name)}`,
		}));
	};

	return {
		agents,
		setAgents,
		loading,
	};
};

export default useFetchAgentsDetails;
